import { useGetUserProfileQuery } from "../lib/api/endpoints/settings/settingsEndpoints";
import { TPERMISSION_NAMES } from "../lib/types/role-management";

export const useGetUser = () => {
  const res = useGetUserProfileQuery();
  const user = res?.data?.payload;
  const roles = user?.roles || [];
  const permissions = roles.map((role) => role.permissions).flat();
  const canUser = (accessLevels: TPERMISSION_NAMES[]) =>
    accessLevels.every((level) => permissions.find((p) => p.name === level)) ||
    !!permissions.find((p) => p.name === "FULL_ACCESS");

  const isSuperAdmin = permissions.some((p) => p.name === "FULL_ACCESS");

  return { ...res, user, permissions, canUser, isSuperAdmin };
};
